<div class="grid" style="margin-top: 8px;">
  <div class="col-12 lg:col-5 flex flex-column">
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.kpiInfo' | transloco}}</h4></div>
      <hr>
      <div class="hidden xl:flex">
        <table class="details-table striped-table" *ngIf="kpi">
          <tr>
            <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
            <td class="pr-1"><app-clipboard-label [value]="kpi.uuid" [copiedValue]="kpi.uuid"></app-clipboard-label></td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.description' | transloco}}</td>
            <td>{{kpi.description}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'model.tenant' | transloco}}</td>
            <td>{{kpi.tenant?.name}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'model.organization' | transloco}}</td>
            <td>{{kpi.organization?.name}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.timePeriod' | transloco}}</td>
            <td>{{kpi.timePeriod}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.operation' | transloco}}</td>
            <td>{{kpi.operation}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.timezone' | transloco}}</td>
            <td>{{kpi.timezone}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'attribute.calculateIfMissingData' | transloco}}</td>
            <td>{{'common.' + kpi.calculateIfMissingData | transloco}}</td>
          </tr>
          <tr>
            <td class="p-3 bold">{{'model.sensorType' | transloco}}</td>
            <td>{{kpi.measurementType?.sensor}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
